import React from 'react';
import Collapsible from 'react-collapsible';
import QuestionContent from './QuestionContent';
import {observer, inject} from 'mobx-react';
import {observe} from 'mobx';
import _ from 'lodash';
import draftToHtml from 'draftjs-to-html';
import { convertToRaw } from 'draft-js';
import classNames from 'classnames';
import QuestionAccordionHeader from './QuestionAccordionHeader';

@inject('publicWebinarCreate')
@inject('deleteModal')
@inject('user')
@observer
export default class AccordionQuestion extends React.Component {


  handleDelete = () => {
    let currentModule = this.props.publicWebinarCreate.modules[this.props.moduleIndex];
    let currentQuestionIndex = _.findIndex(currentModule.questions_attributes, el => el.key === this.props.questionIndex);
    let currentQuestion = this.props.publicWebinarCreate.modules[this.props.moduleIndex].questions_attributes[currentQuestionIndex];
    if(currentQuestion.id)
      this.props.deleteModal.eventDelete({type: 'question', id: currentQuestion.id, index: currentQuestionIndex, moduleId: this.props.moduleIndex });
    else
      this.props.publicWebinarCreate.deleteQuestion(this.props.moduleIndex, currentQuestionIndex )
  };

  handler = () => {
    this.props.publicWebinarCreate.openQuestion(this.props.moduleIndex,this.props.questionIndex )
  };

  render (){
    let currentModule = this.props.publicWebinarCreate.modules[this.props.moduleIndex];
    let currentQuestionIndex = _.findIndex(currentModule.questions_attributes, el => el.key === this.props.questionIndex);

    let currentQuestion = currentModule.questions_attributes[currentQuestionIndex];
    let newCaption = '';

    // if(currentQuestion.text !== '') {
    //   newCaption = document.createElement('div');
    //   newCaption.innerHTML = draftToHtml(convertToRaw(currentQuestion.text.getCurrentContent())).trim();
    //   newCaption = newCaption.textContent;
    // }

    const data = {
      icon: 'ic-flag-ico',
      caption: `Question ${currentQuestionIndex + 1}`
    };

    let currentErrors;
    if(this.props.publicWebinarCreate.modulesError.length - 1 < this.props.moduleIndex)
      currentErrors = {};
    else
    if(this.props.publicWebinarCreate.modulesError[this.props.moduleIndex].questionError.length - 1 < [this.props.questionIndex])
      currentErrors = {};
    else
      currentErrors = this.props.publicWebinarCreate.modulesError[this.props.moduleIndex].questionError[this.props.questionIndex];

    const questionHeader = (
      <div className={classNames({'question-has-error': !_.isEmpty(currentErrors) })}>
        <QuestionAccordionHeader caption={!!data.caption ? data.caption.substr(0,100) : 'Question text'}
                                 candelete={this.props.user.getUser().role === 'admin' || !currentQuestion.id }
                                 handleDelete={this.handleDelete}/>
      </div>
      );
    return(
      <Collapsible
        className="question-accordion-item"
        openedClassName="question-accordion-item is-active"
        open={currentModule.openedQuestion === currentQuestion.key}
        trigger={questionHeader}
        handleTriggerClick={this.handler}>
        <QuestionContent questionIndex={currentQuestionIndex} moduleIndex={this.props.moduleIndex} />

      </Collapsible>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/creat_public_webinar/create_module/create_question/AccordionQuestion.jsx